/**
 * Grupos musculares compartidos entre la Biblioteca (`LibraryScreen`) y el
 * picker del editor (`ExercisePickerModal`).
 *
 * Por qué existe: el catálogo tiene 24 músculos individuales (Cuádriceps,
 * Glúteo, Isquios, Dorsal, Espalda alta, Lumbares, Trapecio, etc.) pero el
 * coach piensa en grupos macros ("Pierna", "Espalda"). Sin agrupación, filtrar
 * por "Pierna" devolvía 1 ejercicio en lugar de los ~322 reales.
 *
 * Los nombres en `members` están NORMALIZADOS (lowercase, sin acentos) — el
 * search del catálogo los compara contra el muscle normalizado del ejercicio.
 */

export interface MuscleGroup {
  label: string;
  members: string[];
}

/** Grupos canónicos. El orden es el de presentación en la UI. */
export const MUSCLE_GROUPS: MuscleGroup[] = [
  { label: "Pecho",     members: ["pecho", "serrato"] },
  { label: "Espalda",   members: ["espalda", "espalda alta", "dorsal", "lumbares", "trapecio", "escapula"] },
  { label: "Hombro",    members: ["hombro"] },
  { label: "Bíceps",    members: ["biceps"] },
  { label: "Tríceps",   members: ["triceps"] },
  { label: "Antebrazo", members: ["antebrazo"] },
  { label: "Pierna",    members: ["pierna", "cuadriceps", "isquios", "femoral", "gluteo", "aductores", "abductores", "pantorrilla"] },
  { label: "Core",      members: ["abdomen", "core", "oblicuos"] },
  { label: "Cardio",    members: ["cardio"] },
  { label: "Full body", members: ["total", "calistenia"] },
];

/** Devuelve el grupo (label) al que pertenece un muscle individual del catálogo,
 *  o el muscle mismo si no está mapeado. Útil para mostrar "categoría legible"
 *  cuando solo tenés el muscle bruto. */
export function muscleToGroupLabel(muscle: string | null | undefined, normalize: (s: string) => string): string | null {
  if (!muscle) return null;
  const n = normalize(muscle);
  for (const g of MUSCLE_GROUPS) {
    if (g.members.includes(n)) return g.label;
  }
  return muscle;
}
